export default function googleCalendar() {
  const mql = window.matchMedia('(max-width: 640px)');
  mql.addEventListener('change', manipulate);
  manipulate(mql);

  function manipulate(mql) {
    document.querySelectorAll('.rich-text iframe').forEach(iframe => {
      const src = iframe.getAttribute('src') || '';
      if (!/\/calendar\/(embed|htmlembed)/.test(src)) return;
      if (mql.matches) {
        if (!src.includes('&mode=AGENDA')) iframe.src = src + '&mode=AGENDA';
      } else {
        const cleaned = src.replace('&mode=AGENDA', '');
        if (iframe.src !== cleaned) iframe.src = cleaned;
      }
    });
  }
}
